export const Instructions = () => {
  return (
    <div>
      <p>Here Admins can choose how the platform calculates impact:</p>
      <ul>
        <li>Use baseline variables already built into the platform.</li>
        <li>
          Use your organisation’s own data (utilities, IT, HPC) for more
          tailored impact reports.
        </li>
        <li>
          You can send a list of variables to Facility or IT leads for input,
          then propagate them into the system at once.
        </li>
        <li>
          We recommend finalising this before recruiting labs into the platform,
          and reviewing the variables with the appropriate leads biannually.
        </li>
      </ul>
    </div>
  );
};
